import Logger from 'js-logger';

export const logger = Logger;
export default Logger;
